import { Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';

const { Text } = Typography;

export const FormulaBox: FC<{ title?: string; children: React.ReactNode }> = ({
  title = 'Formula',
  children,
}) => (
  <div
    style={{
      background: BRAND_COLORS.primary.deepNavy,
      border: `1px solid ${BRAND_COLORS.secondary.steelBlue}`,
      borderRadius: 6,
      padding: '10px 14px',
      marginTop: 14,
    }}
  >
    <Text
      style={{
        color: BRAND_COLORS.secondary.lightGray,
        fontSize: 11,
        display: 'block',
        marginBottom: 4,
      }}
    >
      {title}
    </Text>
    {children}
  </div>
);
